export default {
    state: {
        orders: null,
        ordersMeta: null,
    },
    mutations: {
        SET_ORDERS_DATA(state, payload){
            state.orders = payload.data;
            state.ordersMeta = payload.meta;
        },
        ADD_TO_ORDERS(state, order){
            state.orders.push(order);
        },
        UNSHIFT_ORDERS(state, order){
            state.orders.unshift(order);
        },
        DELETE_FROM_ORDERS(state, id){
            if (state.orders){
                state.orders = state.orders.filter(order=>order.id!==id);
            }
        },
        UPDATE_ORDER_DATA(state, data){
            if (state.orders){
                state.orders = state.orders.map(item=>{
                    if (item.id === data.id){
                        Object.assign(item, data);
                    }
                    return item;
                });
            }
        },
    },
    actions: {
        getOrders({commit}, payload){
            let url = '/orders?v=1';

            if (payload && payload.page){
                url += `&page=${payload.page}`
            }
            if (payload && payload.query){
                url += `&query=${encodeURIComponent(payload.query)}`
            }

            return window.axios.get(url).then(response=>{
                commit('SET_ORDERS_DATA', response.data);
            });
        },
        editOrder({commit}, payload){
            let url = '/orders/' + payload.data.id;
            return new Promise((resolve, reject)=>{
                window.axios.put(url, payload.data.data).then(response=>{
                    commit('UPDATE_ORDER_DATA', response.data.data);
                    resolve(response);
                }).catch(e=>{
                    reject(e);
                });
            })
        },
        updateOrderStatus({commit}, payload){
            let url = '/orders/' + payload.data.id + '/status';
            return new Promise((resolve, reject)=>{
                window.axios.put(url, payload.data.data).then(response=>{
                    commit('UPDATE_ORDER_DATA', response.data.data);
                    resolve(response);
                }).catch(e=>{
                    reject(e);
                });
            })
        },
        deleteOrder({commit}, payload){
            let url = '/orders/' + payload.data.id;
            return window.axios.delete(url).then(response=>{
                commit('DELETE_FROM_ORDERS', payload.data.id);
            });
        },
    }
}